'use strict'

export default () => {
  // This function is nice to have if we ever need to update
  // how we're getting the token in the future.
  const token = window.localStorage.getItem('MD_accessToken')
  return token || ''
}
